export default __webpack_public_path__ + "static/media/lock_image_close.a0743e53.png";